import loadable from '@loadable/component';
import expertProductTestQuery from './query.graphql';

const ExpertProductTest = loadable(() =>
  import(/* webpackChunkName: "expert" */ './product-test')
);

ExpertProductTest.graphQL = expertProductTestQuery;

ExpertProductTest.variables = ({ slug }) => ({
  slug,
});

export default ExpertProductTest;
